module.exports = __webpack_public_path__ + "static/media/british-categories.d4fed06d.jpg";